/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_None_SuppressionsInputs */

const cs_clients_comm_none_suppressions = /** @type {(inputs: Clients_Comm_None_SuppressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné aktivní blokace`)
};

const en_clients_comm_none_suppressions = /** @type {(inputs: Clients_Comm_None_SuppressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active suppressions`)
};

/**
* | output |
* | --- |
* | "No active suppressions" |
*
* @param {Clients_Comm_None_SuppressionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_none_suppressions = /** @type {((inputs?: Clients_Comm_None_SuppressionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_None_SuppressionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_none_suppressions(inputs)
	return cs_clients_comm_none_suppressions(inputs)
});